import { RouteObject } from 'react-router-dom';
import { PortalPage } from 'modules/gate/pages/PortalPage';
import PortalFrameCache from 'modules/gate/components/PortalFrameCache';

const GATE_ROUTES: RouteObject[] = [
    {
        path: "",
        element: <PortalFrameCache />,
        children: [
            {
                path: "",
                element: <PortalPage page='default_gate' />
            },
            {
                path: ":pageId/*",
                element: <PortalPage />
            }
        ],
    }
];

export default GATE_ROUTES;